module.exports = __webpack_public_path__ + "images/khumbu.jpg?b3c53f8a79545b0158a659185ddc2092";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/khumbu.jpg
// module id = 55
// module chunks = 0